import axios from "@core/plugins/axios.plugin"
import { handleServiceCall } from "@services/helpers"

// =====================
// Types
// =====================

export type ChauffageGraphItem = {
    id: string
    data: string
}

export type ChauffagePeriodeData = Record<
    string,
    { sum?: number; mean?: number; kpi?: number }
>

export type ChauffageGraphsResponse = {
    graphs: ChauffageGraphItem[]
    periode: { data: ChauffagePeriodeData }
    meta: { freq: string }
}

// =====================
// Service
// =====================

/**
 * Service pour les données et graphiques de la page Réglage chaufferie.
 * Appelle GET /api/dapi/chauffage/{buildingId}/data (réponse Plotly + periode pour KPI).
 */
export class ChauffageService {
    /**
     * Récupère les graphiques Plotly et les données de période pour la page Réglage chaufferie.
     * @param buildingId - Identifiant du bâtiment
     * @param dateFrom - Date de début (YYYY-MM-DD)
     * @param dateTo - Date de fin (YYYY-MM-DD)
     * @param controller - Contrôleur d'annulation
     * @returns graphs (liste { id, data }), periode.data (pour KPI), meta.freq
     */
    async getChauffageGraphs(
        buildingId: string,
        dateFrom: string,
        dateTo: string,
        controller?: AbortController
    ): Promise<ChauffageGraphsResponse> {
        return handleServiceCall<ChauffageGraphsResponse>(async () => {
            const { data } = await axios.get<ChauffageGraphsResponse>(
                `/api/dapi/chauffage/${buildingId}/data`,
                {
                    params: { date_from: dateFrom, date_to: dateTo },
                    signal: controller?.signal,
                }
            )
            return data
        })
    }
}
